import { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { Bar } from 'react-chartjs-2'
import { Tag, Col, Tooltip } from 'antd'
import { WeaverLoading } from 'Components'
import { QUERY, VIEWTYPE } from 'Types'
import { setCurrentItem } from 'Actions/explore'
import moment from 'moment'

{ isMoment } = moment

export default PopoverContent = ({ attrKey, item }) ->

  [hoveredItem, setHoveredItem] = useState(undefined)
  [barData, setBarData] = useState({})
  [barDataLoading, setBarDataLoading] = useState(false)
  dispatch = useDispatch()

  loadAttributeData = (key) ->
    timeoutRef = setTimeout(->
      setBarDataLoading(true)
    , 1000)

    attributesResult = await Weaver.MetaQueries.attributesAndCount(item.node.id(), attrKey, item.memberKey, { limit: 99999, graph: item.node.graph })

    setBarData({
      fullCount: attributesResult[0].fullCount
      count: attributesResult.length
      labels: attributesResult.map((attribute) ->
        attribute.value
      )
      datasets: [
        minBarLength: 5
        backgroundColor: 'rgba(0, 0, 0, 0.2)'
        hoverBackgroundColor: 'rgba(31, 125, 204, 0.8)'
        data: attributesResult.map((attribute) ->
          attribute.amount
        )
      ]
    })
    { value, amount } = attributesResult[0]
    setHoveredItem({
      full: value
      truncated: "#{getTruncated(value)} (#{amount})"
      tooltip: formattedTooltip(value)
    })
    clearTimeout(timeoutRef)
    setBarDataLoading(false)

  useEffect( ->
    loadAttributeData()
    undefined
  , [])

  formattedTooltip = (val) ->
    if isMoment(val)
      "#{val.format('YYYY-MMM-DD HH:mm:ss')}"
    else
      val.toString()

  getTruncated = (val) ->
    if isMoment(val)
      "#{val.format('YYYY-MMM-DD HH:mm:ss')}"
    else
      "#{_.truncate(val)}"

  <div style={{ minHeight: 150, minWidth: 350 }}>
    {
      if barDataLoading
        <div style={{ maxHeight: 150, maxWidth: 350, padding: 50 }}><WeaverLoading style={{ width: '100%' }} /></div>
      else
        <div>
          {
            if barData.count isnt barData.fullCount
              <div style={{ textAlign: 'center' }}><Tag>{"#{barData.count} / #{barData.fullCount}"}</Tag></div>
          }
          <Bar data={barData}
              options={{
                barChartDefaults...
                onHover: (e, item) ->
                  count = barData.datasets[item[0]?._datasetIndex]?.data[item[0]?._index]
                  if count?
                    label = item[0]?._view.label
                    setHoveredItem({
                      full: label
                      truncated: "#{getTruncated(label)} (#{count})"
                      tooltip: formattedTooltip(label)
                    })
              }}
              onElementsClick={ ->
                dispatch(setCurrentItem({
                  type: QUERY
                  data: {
                    memberKey: item.memberKey,
                    query: JSON.stringify(
                      new Weaver.Query()
                        .equalTo(attrKey, hoveredItem.full)
                        .hasRelationOut(item.memberKey, item.node)
                    )
                  }
                }))
              }
              height={125}
              width={350}/>
          <Tooltip placement="bottom" title={hoveredItem?.tooltip}>
            <div style={{ textAlign: 'center' }}>&nbsp;{ hoveredItem?.truncated }</div>
          </Tooltip>
        </div>
    }
  </div>

barChartDefaults = {
  legend: { display: false }
  tooltips: { enabled: false }
  scales: {
    yAxes: [{
      gridLines: {
        drawOnChartArea: false
      }
      ticks: {
        beginAtZero: true
        precision: 0
      }
    }]
    xAxes: [{
      display: false
    }]
  }
}
